import axios from 'axios';

export default axios.create({
    // baseURL: 'https://localhost:44383/repos/api/dairyfarm/'
    baseURL: 'https://sasyavatagro.com/repos/api'
});